import React from 'react'
import {Container,Row} from 'reactstrap'


import Socialmedia from './socialmedia'

const Footercomponent=()=>{
   

return(<Container fluid={true} style={{backgroundColor:'#211F1D', color:'white',}}>
    <Row  >
       <p> Follow us on  </p>
      </Row>  
   <Row>  
     
   <Socialmedia id="youtube"></Socialmedia>
   <Socialmedia id="instagram"></Socialmedia>
   <Socialmedia id="linkedin"></Socialmedia>
   <Socialmedia id="facebook"></Socialmedia>
   </Row>
   <hr ></hr>
   <Row> <p>
     mrgamedev07@gmail.com <br></br>
     Thottipalayam<br></br>
     somanur , coimbatore <br></br>
     TN,India
    </p>
   </Row>
 </Container>)
}

export default Footercomponent